module.exports = __webpack_public_path__ + "static/img/02.e3b5378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd108/02.png
// module id = Bj3i
// module chunks = 1